import {
    GET_LISTING_STATUS,
    SET_LISTING_STATUS,
    GET_LISTING,
    SET_LISTING,
    GET_MARKET_REPORT,
    SET_MARKET_REPORT,
    SET_TOTAL_PAGE,
    ADD_SOLD_PICTURE,
    SET_FETCH_MARKET_REPORT_STATUS,
    FETCH_MARKET_REPORT_DATA,
    SET_CURRENT_LISTING_STATUS,
    SET_FETCH_LISTING_STATUS,
    // SET_IS_SEARCH_INIT,
    SET_PAGE_NUM,
    SET_CURRENT_LISTING_NAME,
    // SET_MORE_BTN_TITLE,
    // SET_MORE_BTN_STYLE,
    // SET_LISTING_TITLE,
    SET_SHOW_LISTING_PRICE,
    SET_SHOW_SOLD_LISTING_PRICE,
    UPDATE_SEARCH_PARAMS
} from './constants';
import { marketReportStatus } from '../_config';
import { checkSoldHousePreview } from '@/common/utils';
import { getListingStatus, getSnapshotListing, getMarketReport } from '../api';
export default {
//  set up  md-search  Is it initialized 
    // [SET_IS_SEARCH_INIT]( payload = {}) {
    //     this.isSearchInit = payload.data;
    // },
    //  set up  listingStatus  the value of 
    [SET_LISTING_STATUS](payload = {}) {
        this.listingStatus = [...payload.data];
    },
    //  set up  listing  the value of 
    [SET_LISTING](payload = {}) {
        this.listing = [...payload.data];
    },
    //  set up  marketReport  the value of 
    [SET_MARKET_REPORT](payload = {}) {
        this.marketReport = payload.data;
    },
    //  set up  currentListingStatus  the value of 
    [SET_CURRENT_LISTING_STATUS](payload = {}) {
        this.currentListingStatus = payload.data;
    },
    //  set up  currentListingStatus  the value of 
    [SET_FETCH_LISTING_STATUS](payload = {}) {
        this.fetchListingStatus = payload.data;
    },
    [SET_CURRENT_LISTING_NAME](payload = {}) {
        this.currentListingStatusName = payload.data;
    },
    //  set up  fetchMarketReportStatus  the value of 
    // [SET_FETCH_MARKET_REPORT_STATUS]( payload = {}) {
    //     this.fetchMarketReportStatus = payload.data;
    // },
    //  Set the total number of pages for pagination 
    [SET_TOTAL_PAGE](payload = {}) {
        this.totalPage = payload.data;
    },
    //  set current page 
    [SET_PAGE_NUM](payload = {}) {
        this.pageNum = payload.data;
    },
    //  set up  more button
    // [SET_MORE_BTN_TITLE]( payload = {}) {
    //     this.moreBtnTitle = payload.data;
    // },
    // [SET_MORE_BTN_STYLE]( payload = {}) {
    //     this.moreBtnStyle = payload.data;
    // },
    // [SET_LISTING_TITLE]( payload = {}) {
    //     this.customListingTitle = payload.data;
    // },
    //  whether to display sold listing price
    [SET_SHOW_SOLD_LISTING_PRICE](payload = {}) {
        this.showSoldPrice = payload.data;
    },
    //  whether to display listing price
    [SET_SHOW_LISTING_PRICE](payload = {}) {
        this.showListingPrice = payload.data;
    },
    [UPDATE_SEARCH_PARAMS](payload) {
        this.searchParams = { ...payload };
    },

    //  Obtained from the backend interface  listing status  and assign 
    async [GET_LISTING_STATUS](payload = {}) {
        let ret = await getListingStatus.call(this, payload.data);
        this[SET_LISTING_STATUS]({ data: ret.data });
    },
    //  Obtained from the backend interface  listing  and assign 
    async [GET_LISTING](payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        let ret = await getSnapshotListing.call(this, params);
        if (ret.listings) {
            this[SET_LISTING]({ data: ret.listings });
            //  set pagination 
            this[SET_TOTAL_PAGE]({ data: ret.totalPage });
            //  Complementary map 
            await this[ADD_SOLD_PICTURE]();
        } else {
            console.log('get snapshot listing error');
        }
    },
    //  from   Get the backend interface  market report  and assign 
    async [GET_MARKET_REPORT](payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        params.listingType = 'sold-listing'; //  Write to death 
        let ret = await getMarketReport.call(this, params);
        this[SET_MARKET_REPORT]({ data: ret.data.marketReport });
    },
    // add picture
    async [ADD_SOLD_PICTURE]() {
        const { listing } = this;
        checkSoldHousePreview({ listings: listing });
    },
    async [SET_FETCH_MARKET_REPORT_STATUS](status) {
        if (status) {
            this.fetchMarketReportStatus = status;
            return;
            // return this[SET_FETCH_MARKET_REPORT_STATUS]( { data: status });
        }
        if (!this.hasLocation) {
            status = marketReportStatus.noLocation; // no location
        } else {
            if (this.fetchMarketReportStatus === marketReportStatus.coming) {
                status = marketReportStatus.coming; // coming soon
            } else {
                status = marketReportStatus.loading; // loading
            }
        }
        this.fetchMarketReportStatus = status;
        // this[SET_FETCH_MARKET_REPORT_STATUS]( { data: status });
    },
    async [FETCH_MARKET_REPORT_DATA]() {
        await this[SET_FETCH_MARKET_REPORT_STATUS](); //  set state first 
        if (!this.hasLocation) {
            return; //  no choice location  no request data 
        }
        const params = { ...this.marketReportParams };
        await this[GET_MARKET_REPORT]({ data: params });
        await this[SET_FETCH_MARKET_REPORT_STATUS](marketReportStatus.loaded);
    }
};
